import { PageLayout } from "../";
import { DashboardCard } from "../../components";
import { UserService } from "../../services";
import { AgendaDashboard, LocationLineChart, ServiceTypeStackedBarChart } from "./components";

export function HomePage() {
  if (!UserService.isSignedIn()) return <></>;

  return (
    <PageLayout>
      <AgendaDashboard />
      <div className="row">
        <div className="col col-24 col-lg-12 px-0">
          <DashboardCard title="Bookings Per Week">
            <LocationLineChart/>
          </DashboardCard>
        </div>
        <div className="col col-24 col-lg-12 px-0">
          <DashboardCard title="Bookings Per Day">
            <ServiceTypeStackedBarChart/>
          </DashboardCard>
        </div>
      </div>
    </PageLayout>
  );
}
